import React from 'react';
import { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import client from './graphql/apolloClient';

// Importing Common
import Loader from './common/Loader';

// Importing components
import PageTitle from './components/PageTitle';

// Importing pages
import SignInPage from './pages/Authentication/SignInPage';
import SignUpPage from './pages/Authentication/SignUpPage';
import SetNewPassword from './pages/Authentication/SetNewPasswordPage';
import ResetPasswordPage from './pages/Authentication/ResetPasswordPage';
import ChangePasswordPage from './pages/Authentication/ChangePasswordPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import TimecardPage from './pages/Dashboard/Timecard/TimecardPage';
import AttendancePage from './pages/Dashboard/Attendance/AttendancePage';
import ManageAttendancePage from './pages/Dashboard/Manage/ManageAttendancePage';
import UserManagementPage from './pages/Dashboard/Manage/UserManagementPage';

function App() {
  const [loading, setLoading] = useState<boolean>(true);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return (
    <ApolloProvider client={client}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <PageTitle title="ログイン | ark" />
                  <SignInPage />
                </>
              }
            />
            <Route
              path="/auth/signup"
              element={
                <>
                  <PageTitle title="サインアップ | ark" />
                  <SignUpPage />
                </>
              }
            />
            <Route
              path="/setNewPassword"
              element={
                <>
                  <PageTitle title="新しいパスワード | ark" />
                  <SetNewPassword />
                </>
              }
            />
            <Route
              path="/reset-password"
              element={
                <>
                  <PageTitle title="パスワードリセット | ark" />
                  <ResetPasswordPage />
                </>
              }
            />
            <Route
              path="/dashboard"
              element={
                <>
                  <PageTitle title="ダッシュボード | ark" />
                  <DashboardPage />
                </>
              }
            />
            <Route
              path="/timecard"
              element={
                <>
                  <PageTitle title="タイムカード | ark" />
                  <TimecardPage />
                </>
              }
            />
            <Route
              path="/attendance"
              element={
                <>
                  <PageTitle title="勤怠表 | ark" />
                  <AttendancePage />
                </>
              }
            />
            <Route
              path="/manage/attendance"
              element={
                <>
                  <ManageAttendancePage />
                </>
              }
            />
            <Route
              path="/manage/users"
              element={
                <>
                  <PageTitle title="ユーザー管理 | ark" />
                  <UserManagementPage />
                </>
              }
            />
            <Route
              path="/change-password"
              element={
                <>
                  <PageTitle title="パスワード変更 | ark" />
                  <ChangePasswordPage />
                </>
              }
            />
          </Routes>
        </>
      )}
    </ApolloProvider>
  );
}

export default App;
